module.exports = __webpack_public_path__ + "files/a985ad72552ad069537d6eea81e719c7.json";


//////////////////
// WEBPACK FOOTER
// ./config/manifest.json
// module id = 758
// module chunks = 27